var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyIcon08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.32964 4.36189C1.87394 3.31415 4.72952 0.773133 7.03396 0.279378C8.067 0.0580304 8.44562 0.629123 8.49348 1.46063C13.1549 1.99931 17.5076 5.9253 18.5064 10.6884C18.7764 11.9769 18.7754 13.204 18.5423 14.3195L19.6797 14.3014C19.135 15.7927 17.3226 18.9126 13.0557 19.8072C12.8933 19.8413 12.7314 19.8683 12.5696 19.8885C12.1626 19.9483 11.7401 19.9793 11.3044 19.9793C6.2511 19.9793 1.28264 15.8197 0.206935 10.6884C-0.305448 8.24432 0.157809 6.02062 1.32964 4.36189Z",
    fill: "#9F163D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0158 18.4306C17.9775 18.4306 21.1359 14.3095 20.0701 9.2258C19.0044 4.14213 14.1181 0.0209961 9.1564 0.0209961C4.19465 0.0209961 1.03631 4.14213 2.10205 9.2258C3.16779 14.3095 8.05403 18.4306 13.0158 18.4306Z",
    fill: "#EB323A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7924 16.0217C16.6894 16.0217 19.1702 12.7865 18.3336 8.79554C17.4969 4.80462 13.6596 1.56934 9.7626 1.56934C5.86565 1.56934 3.38479 4.80462 4.22144 8.79554C5.05809 12.7865 8.89544 16.0217 12.7924 16.0217Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5544 13.7848C15.4388 13.7848 17.287 11.4472 16.6825 8.56354C16.078 5.67992 13.2497 3.34229 10.3653 3.34229C7.48085 3.34229 5.63264 5.67992 6.23716 8.56354C6.84168 11.4472 9.67001 13.7848 12.5544 13.7848Z",
    fill: "#EB323A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4636 11.6231C14.3119 11.6231 15.5028 10.1566 15.1235 8.34768C14.7443 6.53872 12.9386 5.07227 11.0903 5.07227C9.24199 5.07227 8.05108 6.53872 8.43031 8.34768C8.80954 10.1566 10.6153 11.6231 12.4636 11.6231Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1161 9.96405C13.0283 9.96405 13.6161 9.2403 13.4289 8.3475C13.2417 7.45471 12.3505 6.73096 11.4383 6.73096C10.5261 6.73096 9.93835 7.45471 10.1255 8.3475C10.3127 9.2403 11.2039 9.96405 12.1161 9.96405Z",
    fill: "#EB323A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon08);
export default __webpack_public_path__ + "static/media/company-icon-08.866dfbc44e796f0406014272c247b070.svg";
export { ForwardRef as ReactComponent };